import { render, staticRenderFns } from "./PerPeriodMessage.vue?vue&type=template&id=63982a32&scoped=true&"
import script from "./PerPeriodMessage.vue?vue&type=script&lang=js&"
export * from "./PerPeriodMessage.vue?vue&type=script&lang=js&"
import style0 from "./PerPeriodMessage.vue?vue&type=style&index=0&id=63982a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63982a32",
  null
  
)

export default component.exports